(function () {
  if (window.__aiGalleryCoordinatorInit) return;
  window.__aiGalleryCoordinatorInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSlider(root) {
    if (root.__aiInited) return;
    root.__aiInited = true;

    var track = root.querySelector('[data-ai-track]');
    if (!track) return;

    var prevBtn = root.querySelector('[data-ai-prev]');
    var nextBtn = root.querySelector('[data-ai-next]');

    var AUTOPLAY    = root.getAttribute('data-ai-autoplay') === 'true' && !reduce;
    var SPEED       = (parseFloat(root.getAttribute('data-ai-speed')) || 4) * 1000;
    var PAUSE_HOVER = root.getAttribute('data-ai-pausehover') === 'true';
    var GAP         = parseFloat(root.getAttribute('data-ai-gap')) || 0;

    var timer = null, inView = false;

    function firstItem() { return track.querySelector('[class*="ai-photo-gallery__item-"]'); }
    function stepSize() {
      var item = firstItem();
      var w = item ? item.getBoundingClientRect().width : track.clientWidth;
      return Math.round(w + GAP);
    }
    function atEnd()   { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }
    function atStart() { return track.scrollLeft <= 2; }
    function next() {
      if (atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: stepSize(), behavior: 'smooth' });
    }
    function prev() {
      if (atStart()) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else track.scrollBy({ left: -stepSize(), behavior: 'smooth' });
    }

    function stop()  { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (!AUTOPLAY || !inView || document.hidden) return; stop(); timer = setInterval(next, SPEED); }
    function restart() { stop(); start(); }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });

    if (PAUSE_HOVER) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    }, { passive: true });

    if (AUTOPLAY && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        inView = e[0].isIntersecting;
        if (inView) start(); else stop();
      }, { threshold: 0.15 }).observe(root);
    } else {
      inView = true;
      start();
    }

    var resumeT = null;
    track.addEventListener('touchstart', function () {
      stop();
      clearTimeout(resumeT);
      resumeT = setTimeout(start, Math.max(SPEED, 3000));
    }, { passive: true });

    var isDown = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      isDown = true; moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('ai-dragging');
      stop();
    });
    window.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('ai-dragging');
      restart();
    });
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function mergeGroups() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('.js-ai-gallery'));
    if (!roots.length) return;

    var keys = [], groups = [];
    function groupFor(key) {
      var idx = keys.indexOf(key);
      if (idx === -1) { keys.push(key); groups.push([]); idx = groups.length - 1; }
      return groups[idx];
    }

    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      if (r.__aiMerged) continue;
      var key = r.closest('.shopify-section') || r.parentNode;
      groupFor(key).push({ root: r, key: key });
    }

    for (var g = 0; g < groups.length; g++) {
      var list = groups[g];
      if (!list.length) continue;

      var host = list[0].root;
      var sectionKey = list[0].key;
      var hostTrack = host.querySelector('[data-ai-track]');

      if (hostTrack) {
        for (var k = 1; k < list.length; k++) {
          var other = list[k].root;
          var otherTrack = other.querySelector('[data-ai-track]');
          if (otherTrack) {
            while (otherTrack.firstElementChild) {
              hostTrack.appendChild(otherTrack.firstElementChild);
            }
          }
          other.__aiMerged = true;
          var op = other?.parentNode;
if (op && other) op.removeChild(other);
if (op && op !== sectionKey && op.querySelectorAll('.js-ai-gallery').length === 0 && op.children.length === 0) {
  op.style.display = 'none';
}
        }
      }

      host.__aiMerged = true;
      initSlider(host);
    }
  }

  function run() { mergeGroups(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', run);
})();